import * as React from 'react';
export const IcTemperatureUp = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.71 6.29l-2-2a.999.999 0 00-1.42 0l-2 2a1.004 1.004 0 101.42 1.42l.29-.3V19a1 1 0 002 0V7.41l.29.3a1 1 0 001.42 0 .998.998 0 000-1.42zM12 7a4 4 0 10-8 0v6a4.94 4.94 0 00-1 3 5 5 0 1010 0 4.94 4.94 0 00-1-3V7zM8 18a2 2 0 01-2-2 2 2 0 011-1.72V8a1 1 0 012 0v6.28A2 2 0 0110 16a2 2 0 01-2 2z'
      fill='currentColor'
    />
  </svg>
);
